// import React, { useEffect, useState } from "react";
// import serviceApi from "../../../services/serviceApi";
// import environment from "../../../environments/environment";

// interface EventItem {
//     id: string;
//     title: string;
//     type: string;
//     time: string;
//     date: string;
//     description: string;
//     incharge?: string;
// }

// interface EventResponse {
//     status: string;
//     dataList: EventItem[];
// }

// const EventsContent: React.FC = () => {
//     const [events, setEvents] = useState<EventItem[]>([]);
//     const [isLoading, setIsLoading] = useState<boolean>(true);
//     const [error, setError] = useState<string | null>(null);

//     useEffect(() => {
//         Events();
//     }, []);


//     const Events = async () => {
//         setIsLoading(true);
//         setError(null);

//         try {
//             const res = await serviceApi.get<EventResponse>(
//                 environment.events
//             );

//             if (res?.status === "SUCCESS") {
//                 setEvents(res.dataList || []);
//             } else {
//                 setEvents([]);
//                 setError("Failed to load events");
//             }
//         } catch (err) {
//             console.error("Error fetching events:", err);
//             setError("An error occurred while fetching events");
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     return (
//         <div className="notification-page">
//             {isLoading && (
//                 <div className="loading-overlay">
//                     <div className="loading-overlay__content">
//                         <div className="spinner spinner--lg"></div>
//                         <span className="loading-text">Loading events...</span>
//                     </div>
//                 </div>
//             )}
//             <h2 className="title-text notification-heading">Events</h2>
//             {error && <p className="error-text">{error}</p>}
//             {!isLoading && !error && events.length > 0 && (
//                 <div style={{ padding: "10px", display: "flex", flexDirection: "column", gap: "15px" }}>
//                     {events.map((event) => (
//                         <div key={event.id} className="event-container" style={{ margin: 0, width: "100%" }}>
//                             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//                                 <div>
//                                     <h3 className="title-text" style={{ margin: 0, color: "var(--colorPrimaryDark)" }}>
//                                         {event.title}
//                                     </h3>
//                                     <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "4px" }}>
//                                         <i className="fa-regular fa-calendar-days" style={{ color: "var(--colorAccent)", fontSize: "14px" }}></i>
//                                         <span className="event-date" style={{ fontSize: "13px", color: "#666", fontWeight: "500", position: 'static' }}>
//                                             {event.date} | {event.time}
//                                         </span>
//                                     </div>
//                                 </div>

//                                 <span style={{
//                                     background: "var(--colorAccent)",
//                                     color: "#fff",
//                                     padding: "4px 10px",
//                                     borderRadius: "20px",
//                                     fontSize: "11px",
//                                     fontWeight: "bold",
//                                     textTransform: "uppercase"
//                                 }}>
//                                     {event.type || 'EVENT'}
//                                 </span>
//                             </div>

//                             <hr style={{ border: "0", borderTop: "1px solid #eee", margin: "12px 0" }} />

//                             {/* Bottom Section: Description */}
//                             <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
//                                 <p className="event-description" style={{ margin: 0 }}>
//                                     {event.description}
//                                 </p>
//                                 {event.incharge && event.incharge !== "999" && (
//                                     <span style={{ fontSize: "12px", color: "#999", fontStyle: "italic", marginTop: "5px" }}>
//                                         <i className="fa-solid fa-user-tie" style={{ marginRight: "5px" }}></i>
//                                         In-charge: {event.incharge}
//                                     </span>
//                                 )}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             )}
//             {!isLoading && !error && events.length === 0 && (
//                 <p className="no-events">No events available at the moment</p>
//             )}
//         </div>
//     );
// };

// export default EventsContent;

import React, { useEffect, useState } from "react";
import serviceApi from "../../../services/serviceApi";
import environment from "../../../environments/environment";

interface EventItem {
    id: string;
    title: string;
    type: string;
    time: string;
    date: string;
    description: string;
    incharge?: string;
}

interface EventResponse {
    status: string;
    dataList: EventItem[];
}

const EventsContent: React.FC = () => {
    const [events, setEvents] = useState<EventItem[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    // Get current month name automatically on load (e.g., "January", "May", etc.)
    const [selectedMonth, setSelectedMonth] = useState<string>(
        new Date().toLocaleString("en-US", { month: "long" })
    );

    // Re-run whenever selectedMonth updates
    useEffect(() => {
        fetchEvents(selectedMonth);
    }, [selectedMonth]);

    const fetchEvents = async (monthName: string) => {
        setIsLoading(true);
        setError(null);

        try {
            // Standard restful filter setup: /events?month=May
            const res = await serviceApi.get<EventResponse>(
                `${environment.events}?month=${monthName}`
            );

            if (res?.status === "SUCCESS") {
                setEvents(res.dataList || []);
            } else {
                setEvents([]);
                setError("Failed to load events");
            }
        } catch (err) {
            console.error("Error fetching events:", err);
            setError("An error occurred while fetching events");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="notification-page">
            {isLoading && (
                <div className="loading-overlay" style={{ zIndex: 9999 }}>
                    <div className="loading-overlay__content">
                        <div className="spinner spinner--lg"></div>
                        <span className="loading-text">Loading events...</span>
                    </div>
                </div>
            )}

            {/* Header Layout: Structured using CSS Grid for perfect centering and isolation */}
            <div style={{
                display: "grid",
                gridTemplateColumns: "1fr auto 1fr",
                alignItems: "center",
                marginTop: "25px", // Creates a clear, safe buffer away from the upside menu card
                marginBottom: "20px",
                width: "100%",
                padding: "0 10px"
            }}>
                {/* 1. Left placeholder to push the heading to absolute center */}
                <div />

                {/* 2. Heading: Positioned right in the middle */}
                <h2 className="title-text notification-heading" style={{ margin: 0, textAlign: "center" }}>
                    Events
                </h2>

                {/* 3. Dropdown Container: Float cleanly on the right with independent breathing room */}
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <select
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                        style={{
                            padding: "6px 12px",
                            borderRadius: "6px",
                            border: "1px solid #ccc",
                            fontSize: "14px",
                            backgroundColor: "#fff",
                            cursor: "pointer"
                        }}
                    >
                        <option value="January">January</option>
                        <option value="February">February</option>
                        <option value="March">March</option>
                        <option value="April">April</option>
                        <option value="May">May</option>
                        <option value="June">June</option>
                        <option value="July">July</option>
                        <option value="August">August</option>
                        <option value="September">September</option>
                        <option value="October">October</option>
                        <option value="November">November</option>
                        <option value="December">December</option>
                    </select>
                </div>
            </div>

            {error && <p className="error-text" style={{ textAlign: "center", color: "red" }}>{error}</p>}

            {!isLoading && !error && events.length > 0 && (
                <div>
                    {events.map((event) => (
                        <div key={event.id} className="event-container" style={{ marginBottom: "15px"}}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                                <div>
                                    <h3 className="title-text" style={{ margin: 0, color: "var(--colorPrimaryDark)" }}>
                                        {event.title}
                                    </h3>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "4px" }}>
                                        <i className="fa-regular fa-calendar-days" style={{ color: "var(--colorAccent)", fontSize: "14px" }}></i>
                                        <span className="event-date" style={{ fontSize: "13px", color: "#666", fontWeight: "500", position: 'static' }}>
                                            {event.date} | {event.time}
                                        </span>
                                    </div>
                                </div>

                                <span style={{
                                    background: "var(--colorAccent)",
                                    color: "#fff",
                                    padding: "4px 10px",
                                    borderRadius: "20px",
                                    fontSize: "11px",
                                    fontWeight: "bold",
                                    textTransform: "uppercase"
                                }}>
                                    {event.type || 'EVENT'}
                                </span>
                            </div>

                            <hr style={{ border: "0", borderTop: "1px solid #eee", margin: "12px 0" }} />

                            <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                <p className="event-description" style={{ margin: 0 }}>
                                    {event.description}
                                </p>
                                {event.incharge && event.incharge !== "999" && (
                                    <span style={{ fontSize: "12px", color: "#999", fontStyle: "italic", marginTop: "5px" }}>
                                        <i className="fa-solid fa-user-tie" style={{ marginRight: "5px" }}></i>
                                        In-charge: {event.incharge}
                                    </span>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {!isLoading && !error && events.length === 0 && (
                <p className="no-events" style={{ textAlign: "center", marginTop: "30px", color: "#777" }}>
                    No events available for {selectedMonth}
                </p>
            )}
        </div>
    );
};

export default EventsContent;